<template>
  <main data-id="0" data-page="new_post">
    <section class="prev-page-section" style="background-image:url(/static-assets/img/contact-img.jpg);">
      <div class="container">
        <div v-bind="dKey('bgTitle')" class="grey-title-block resp-number">text</div>
      </div>
    </section>
    <section class="news-section">
        <div class="container">
          <div class="row title-wrapper">
            <div class="col-sm-12 wow fadeInLeft pb-5" data-wow-duration="2s" data-wow-delay=".5s">
              <span v-bind="dKey('subtitle')" class="section-title">subtitle</span>
              <h3 v-bind="dKey('title')">title</h3>
            </div>
            <div class="col-sm-12 about-first-content">
              <div class="img-thumbnail float-right content-image">
                <img id="post-main-image" v-bind:src="image" class="" alt="">
                <div v-if="$root.isAdmin()" class="img-buttons mt-1">
                  <div v-for="error in errors" class="alert alert-danger mt-1 mb-1 ml-0 mr-0 show fade" role="alert">{{error}}</div>
                  <button @click="uploadImage" class="btn btn-primary">Select Image</button>
                  <input id="upload-image" type="file" name="image" value="" class="hidden" />
                  <span v-if="$root.isAdmin()" v-bind="dKey('image')" class="hidden">{{image}}</span>
                </div>
              </div>
              <div data-type="editor" v-bind="dKey('content')">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                <p>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
              </div>
            </div>
            <div v-if="$root.isAdmin()" class="col-sm-12 inputs-wrapper">
              <div>
                <label>Post URl</label>
                <span v-model="info.url" v-bind="dKey('url')" class="hidden">{{info.url}}</span>
                <input type="text" name="url" v-model="info.url" placeholder="Post URL" autocomplete="off" />
              </div>
            </div>
          </div>
        </div>
    </section>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'News',

  data() {
    return {
      url: '',
      info: {},
      image: null,
      postId: 0,
      pageName: 'post',
      errors: []
    }
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })

    this.$root.styleLoader('/static-assets/js/summernote/summernote-bs4.css', () => {
      this.$root.scriptLoader('/static-assets/js/summernote/summernote-bs4.min.js', () => {
        $('[data-type="editor"]').summernote({
          airMode: true,
          popover: {
            air: [
              ['style', ['style']],
              ['font', ['fontname', 'fontsize', 'forecolor', 'backcolor', 'color', 'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
              ['para', ['ul', 'ol', 'paragraph', 'height']],
              ['insert', ['picture', 'link', 'video', 'table']]

            ], image: [
              ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
              ['float', ['floatLeft', 'floatRight', 'floatNone']],
              ['remove', ['removeMedia']]
            ], link: [
              ['link', ['linkDialogShow', 'unlink']]
            ],
          },

          events: {
            'insertParagraph': function (evt) {
              if (evt.which === 13 || evt.keyCode === 13)
                evt.shiftKey = true;
            }
          }
        })
      })
    })
  },

  created() {
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    uploadImage() {
      let $input = $('#upload-image')
      let accessToken = this.$root.accessToken
      let self = this

      $input.off('change').on('change', function(){
        let data = new FormData

        data.append('img', $input.prop('files')[0])

        HTTP.post('uploaders/images/upload?access_token=' + accessToken, data).then(response => {
          self.errors = []

          if (response.data.result.files && response.data.result.files.img) {
            self.image = null
            self.image = '/static-assets/images/' + response.data.result.files.img[0].name
          }
        }).catch(e => {
          self.errors = []
          self.errors.push(e.response.data.error.message.indexOf('maxFileSize') != -1 ? 'Объем изображение должен быть не более 2Мб.' : e.response.data.error.message)
        })
      })

      $input.trigger('click')
    }
  }
}

</script>

<style scoped>

@font-face{
  font-family: "summernote";
  font-style: normal;
  font-weight: normal;
  src:url("/static-assets/js/summernote/font/summernote.eot?4c7e83314b68cfa6a0d18a8b4690044b");
  src:url("/static-assets/js/summernote/font/summernote.eot?4c7e83314b68cfa6a0d18a8b4690044b#iefix") format("embedded-opentype"),
  url("/static-assets/js/summernote/font/summernote.woff?4c7e83314b68cfa6a0d18a8b4690044b") format("woff"),
  url("/static-assets/js/summernote/font/summernote.ttf?4c7e83314b68cfa6a0d18a8b4690044b") format("truetype")
}

.content-image {
  margin-left: 20px;
  margin-bottom: 20px;
  max-width: 50%;
}

.content-image img {
  max-width: 100%;
}

.inputs-wrapper input {
  background: transparent;
}

.img-buttons {
  position: relative;
  z-index: 1000;
}

</style>
